import { cn } from '../../utils/classNames';
import PaginationNavigation from './PaginationNavigation';
import PaginationSummary from './PaginationSummary';

const rowClasses = 'flex justify-between items-center';

const TablePagination = ({
  startEntry,
  endEntry,
  totalCount,
  pageSize,
  onPageSizeChange,
  currentPage,
  totalPages,
  onPageChange,
  className,
  summaryGapClass,
}) => (
  <div className={cn(rowClasses, className)}>
    <PaginationSummary
      startEntry={startEntry}
      endEntry={endEntry}
      totalCount={totalCount}
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange}
      gapClass={summaryGapClass}
    />
    {totalPages > 1 && (
      <PaginationNavigation
        handlePageChange={onPageChange}
        currentPage={currentPage}
        totalPages={totalPages}
      />
    )}
  </div>
);

export default TablePagination;
